import React from 'react';
import { Lightbulb, PenTool, Code, Rocket } from 'lucide-react';
import './ProcessSteps.css';

const steps = [
  {
    icon: <Lightbulb size={40} />,
    title: 'Idea Discussion',
    description: 'We listen to your vision, understand your goals, and define the project scope together.'
  },
  {
    icon: <PenTool size={40} />,
    title: 'Design & Prototyping',
    description: 'We create wireframes and interactive prototypes to visualize your product before development.'
  },
  {
    icon: <Code size={40} />,
    title: 'Development',
    description: 'Our agile team builds your product with clean code, regular updates, and transparent communication.'
  },
  {
    icon: <Rocket size={40} />,
    title: 'Launch & Support',
    description: 'We deploy your product, provide training, and offer ongoing support to ensure your success.'
  }
];

const ProcessSteps = () => {
  return (
    <section className="process-steps section">
      <div className="container">
        <h2 className="section-title">
          How We Turn Your Idea Into <span className="blue-text">Reality</span>
        </h2>

        <p className="section-subtitle">
          A proven process that takes you from concept to launch with confidence
        </p>

        <div className="process-grid">
          {steps.map((step, index) => (
            <div key={index} className="process-card">
              <div className="process-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;